import { useTranslation } from "react-i18next";
import { Link, Stack, SvgIcon, Typography } from "@mui/material";
import { Delete as DeleteIcon } from "@mui/icons-material";
import { useSharedErrorStyles } from "../sharedErrorStyles";
import { useDeviceType } from "@hooks/useDeviceType";
import RetryIcon from "@static/icons/Retry.svg";
import HelpIcon from "@static/icons/Help.svg";
import { WORDPRESS_URL } from "@constants";
import { LabeledButton } from "@common/LabeledButton/LabeledButton";

interface IBroadbandOtherErrorContentProps {
    onChangeUan?(): void;
    onRemove?(): void;
}

export const BroadbandOtherErrorContent = (props: IBroadbandOtherErrorContentProps) => {
    const { onChangeUan, onRemove } = props;
    const { t } = useTranslation("cart");
    const { isMobile } = useDeviceType();
    const { classes } = useSharedErrorStyles({ isMobile });

    return (
        <Stack spacing={2}>
            <Typography className={classes.errorTitle} paddingTop={2} variant="large">
                {t("broadband.otherError.message")}
            </Typography>
            <Typography className={classes.errorMessage} variant="normal">
                {t("broadband.otherError.optionsMessage")}
            </Typography>
            {onChangeUan && (
                <div className={classes.retryContainer}>
                    <div className={classes.retryIconContainer}>
                        <SvgIcon className={classes.retryIcon} component={RetryIcon} inheritViewBox />
                        <Typography className={classes.retryMessage} variant="normal">
                            {t("broadband.otherError.changeUanMessage")}
                        </Typography>
                    </div>
                    <Link className={classes.retryLink} variant="normal" onClick={onChangeUan}>
                        {t("broadband.otherError.changeUan")}
                    </Link>
                </div>
            )}
            <div className={classes.retryContainer}>
                <div className={classes.retryIconContainer}>
                    <SvgIcon className={classes.retryIcon} component={HelpIcon} inheritViewBox />
                    <Typography className={classes.retryMessage} variant="normal">
                        {t("broadband.otherError.helpMessage")}
                    </Typography>
                </div>
                <Link
                    className={classes.retryLink}
                    href={`${WORDPRESS_URL}/help-support`}
                    rel="noopener"
                    target="_blank"
                    variant="normal"
                >
                    {t("broadband.otherError.getHelp")}
                </Link>
            </div>
            {onRemove && (
                <div className={classes.removeButtonContainer}>
                    <LabeledButton labelText={t("broadband.remove")} startIcon={<DeleteIcon />} onClick={onRemove}>
                        {t("broadband.remove")}
                    </LabeledButton>
                </div>
            )}
        </Stack>
    );
};
